import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import { Capacitor } from '@capacitor/core';
import VideoCallNotification from '../modules/rocketChat/entities/VideoCallNotification';

export const WAIT = 45000;


export class NotificationPopup extends React.Component {

  static propTypes = {
    notification: PropTypes.shape({
      sender: PropTypes.shape({
        imgUrl: PropTypes.string.isRequired,
        lastname: PropTypes.string.isRequired,
        firstname: PropTypes.string.isRequired
      }),
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      sound: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired
    })
  };

  state = { volume: 100 }

  onAccept = () => {
    const { dispatch, history, notification } = this.props;

    clearTimeout(this.timeout);
    notification.accept(dispatch, history);
  };
  onDecline = () => {
    const { dispatch, notification } = this.props;

    clearTimeout(this.timeout);
    notification.decline(dispatch);
  };
  onTimeOut = () => {
    const { dispatch, notification } = this.props;

    notification.timeOut(dispatch);
  };

  setVolume = (volume) => {
    this.setState({ volume });
  }

  constructor(props) {
    super(props);
    const {dispatch, notification, history} = props;

    this.timeout = setTimeout(this.onTimeOut, WAIT);
    if (notification instanceof VideoCallNotification) {
      notification.notify(dispatch, history);
    }

    if (Capacitor.isAndroid) {
      androidVolume.getSystem(this.setVolume);
    }
  }

  render() {
    const { notification } = this.props;

    return(
      <div className="messagePopup">
        <div className="popupBody">
          <div className="popupUpper">
            <div className="messageHeader">
              <div className="userProfilePic"
                 style={{backgroundImage: `url(${notification.sender.imgUrl})`}}/>
              <div className="userName">
                <b>{notification.sender.firstname} {notification.sender.lastname}</b> {notification.title}
              </div>
            </div>
            {notification.message &&
            <div className="popupMessage">
              {notification.message}
            </div>}
            {notification.sound &&  this.state.volume > 0 && <audio src={notification.sound} autoPlay loop />}
          </div>
          <div className="popupLowerMessage">
            <a className="popupButton" onClick={this.onAccept}>
              <i className={`fa ${notification.icon}`}/>
            </a>
            <a className="popupButton" onClick={this.onDecline}>
              <i className="fa fa-close"/>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(NotificationPopup));
